import type { HilPresentation, HilPresentationAction } from '@bizfirst/hil-types';

export class HilStepReader {
  constructor(
    private readonly step: HilPresentation,
    private readonly envelopeActions: HilPresentationAction[]
  ) {}

  presentationType(): string {
    return this.step.PresentationType ?? '';
  }

  order(): number {
    return this.step.Order;
  }

  title(): string | null {
    return this.step.Title ?? null;
  }

  getFormID(): number | null {
    return this.step.FormID ?? null;
  }

  getFormSchemaJson(): string | null {
    return this.step.FormSchemaJson ?? null;
  }

  getPrePopulate(): Record<string, unknown> {
    return this.step.PrePopulate ?? {};
  }

  getPromptMessage(): string | null {
    return this.step.PromptMessage ?? null;
  }

  getSummaryText(): string | null {
    return this.step.SummaryText ?? null;
  }

  getActions(): HilPresentationAction[] {
    if (this.step.Actions && this.step.Actions.length > 0) {
      return this.step.Actions;
    }
    return this.envelopeActions;
  }

  customData(): Record<string, unknown> {
    return this.step.CustomData ?? {};
  }
}
